module.exports = __webpack_public_path__ + "static/media/about2.db61a3d9.jpg";